export function useRotatingPlaceholder(
    placeholders: string[],
    modelValue: Ref<string | null | undefined>,
    intervalMs = 2000
) {
    const placeholder = ref<string | undefined>(placeholders[0] ?? '')

    let index = 0
    let intervalId: ReturnType<typeof setInterval> | null = null

    const start = () => {
        if (intervalId || modelValue.value) return

        intervalId = setInterval(() => {
            index = (index + 1) % placeholders.length
            placeholder.value = placeholders[index]
        }, intervalMs)
    }

    const stop = () => {
        if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
        }
    }

    watch(modelValue, (value) => {
        if (value) {
            stop()
        } else {
            start()
        }
    })

    onMounted(start)
    onUnmounted(stop)

    return {
        placeholder,
        start,
        stop,
    }
}